import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'src/app/base/services/general/general.service';
import { PersistenciaService } from 'src/app/base/services/persistencia/persistencia.service';
import { UsuarioService } from 'src/app/base/services/usuario/usuario.service';
import { BaseComponent } from 'src/app/models/base-component';
import { PagoVentaComponent } from 'src/app/snapquick/components/pago-venta/pago-venta.component';
import { CampeonatosService } from '../../services/campeonatos/campeonatos.service';

/* Ficha de deudas de un jugador: lo que debe en todos los clubes y campeonatos de la empresa (tarjetas y su parte de
   las deudas divididas del club) y los pagos que hizo. Cada deuda se paga con el pago a cuenta de siempre, marcado como
   pago del jugador, asi baja solo su parte aunque hoy juegue en otro equipo. */
@Component({
    selector: 'app-ficha-deuda-jugador',
    templateUrl: './ficha-deuda-jugador.component.html',
    standalone: false
})
export class FichaDeudaJugadorComponent extends BaseComponent implements OnInit {

  id_jugador:any;
  @Output() alTerminar:EventEmitter<any>  = new EventEmitter<any>();
  ficha:any=null;
  cargando:boolean=true;
  //hubo pagos: quien abrio la ficha debe recargar sus saldos al cerrarla
  hubo_pagos:boolean=false;

  constructor(
    public generalService:GeneralService,
    public persistenciaService:PersistenciaService,
    public usuarioService:UsuarioService,
    public modalService: NgbModal,
    private toastr: ToastrService,
    public campeonatosService:CampeonatosService) {
      super(persistenciaService,modalService,generalService,usuarioService);
  }

  async ngOnInit(): Promise<void> {
    await this.cargarFicha();
  }

  async cargarFicha(){
    this.cargando=true;
    let res:any=await this.campeonatosService.obtenerFichaDeudaJugador(this.id_jugador,this.usuario.id_empresa).toPromise();
    this.cargando=false;
    if(res.tiene_error){
      this.toastr.error(res.mensaje);
      return;
    }
    this.ficha=res;
  }

  pagarDeuda(deuda){
    let modal_pago=this.modalService.open(PagoVentaComponent, {ariaLabelledBy: 'modal-basic-title', backdrop: 'static'});
    modal_pago.componentInstance.venta = {id:deuda.id_venta};
    modal_pago.componentInstance.usuario = this.usuario;
    //con el jugador de la fila: puede ser otro registro del mismo C.I.
    modal_pago.componentInstance.jugador = {id:deuda.id_jugador_deuda,nombre_completo:this.ficha.jugador.nombre_completo,saldo:parseFloat(deuda.saldo)};
    modal_pago.componentInstance.alTerminar.subscribe(async (res) => {
      if(res && res.tiene_error){
        this.toastr.error(res.mensaje);
        return;
      }
      modal_pago.close();
      if(res){
        this.toastr.success(res.mensaje);
        this.hubo_pagos=true;
        await this.cargarFicha();
      }
    });
  }

  cerrarComponente(){
    this.alTerminar.emit({hubo_pagos:this.hubo_pagos});
  }
}
